/**
 * True when a prior successful fetch was recorded in Redux (SPA session cache).
 * @param {number|null|undefined} fetchedAt
 */
export function hasFetchedOnce(fetchedAt) {
  return fetchedAt != null && Number.isFinite(Number(fetchedAt));
}
